import type { CondensateSolutionGasRsoCalculator } from "../../d";

export const solutionGasRsoCalculator: CondensateSolutionGasRsoCalculator =
  params => {
    const {
      pressurePSIA,
      reservoirPressurePSIA,
      temperatureF,
      gasSpecificGravity,
      condensateSpecificGravity,
      gasOilRatio
    } = params;

    // PVT!BJ97, BJ101
    const x =
      7.916 * 10 ** -4 * condensateSpecificGravity ** 1.541 -
      4.561 * 10 ** -5 * temperatureF ** 1.3911;

    // PVT!BJ99, BJ103
    const rsoAt = (pressure: number) =>
      ((pressure / 112.727 + 12.34) * gasSpecificGravity ** 0.8439 * 10 ** x) **
      1.73184;

    // PVT!AW5 caps the in situ Rso at the GOR
    return {
      x,
      solutionGasRsoInSitu: Math.min(rsoAt(pressurePSIA), gasOilRatio),
      solutionGasRsoAtReservoir: rsoAt(reservoirPressurePSIA)
    };
  };
